import React from "react";
import Image from "next/image";
import Link from "next/link";
import { BASE_ASSETS_URL } from "../../../constants/constants";

const BlogCard = ({
  blogImage,
  image,
  imageURL,
  imageWidth = "w-full md:h-[250px] lg:h-[367px] xl:h-[370px]",
  title,
  genre,
  date,
  owner,
  desc,
  blogUrl,
  genreColor,
  customTitle,
  imageBorders,
  localAsset = false,
}) => {
  return (
    <Link
      href={blogUrl}
      target="_blank"
      className={`group w-full flex flex-col gap-6 text-center`}
    >
      <div className="w-full flex items-center justify-center mx-auto">
        {(imageURL || image) && (
          <div className={`w-full h-[367px] bg-surface-light `}>
            <Image
              src={
                imageURL
                  ? imageURL
                  : localAsset
                  ? require(`@assets/articles/${image}`)
                  : `${BASE_ASSETS_URL}/v2/articles/${image}`
              }
              alt={title}
              width={100}
              height={100}
              className="w-full h-full object-cover"
            />
          </div>
        )}
        {blogImage && (
          <div className={`w-full h-[367px] bg-surface-light `}>
            <Image
              src={`${blogImage}`}
              alt={title}
              width={100}
              height={100}
              className="w-full h-full object-cover"
            />
          </div>
        )}
      </div>
      {/* <div className="flex justify-between items-center gap-4 md:px-0 px-2 ">
        <p className={`  font-semibold text-black text-xl`}>{genre}</p>
        <p className="">{date}</p>
      </div> */}
      <div
        className={`text-left font-bold md:px-0 px-2 ${
          customTitle
            ? customTitle
            : "text-xl leading-snug lg:text-[28px] md:leading-[36px]"
        }`}
      >
        {title}
      </div>
      <div className="md:px-0 px-2">
        <p className="text-left md:text-[22px] md:leading-[32px] text-base leading-snug font-medium text-gray-600">
          {desc}
        </p>
        {owner && (
          <div className="flex justify-start items-center gap-2 mt-8">
            <Image
              width={48}
              height={48}
              src={owner?.img}
              alt="Owner"
              className="rounded-full"
            />
            <div className="flex flex-col items-start">
              <h3 className="md:text-xl text-base font-semibold text-gray-800">
                {owner?.name}
              </h3>
              <p className="md:text-base text-sm font-semibold text-gray-500">
                {owner?.title}
              </p>
            </div>
          </div>
        )}
      </div>
    </Link>
  );
};

export default BlogCard;
